var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoomBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 50,
    cy: 94.76,
    rx: 13.69,
    ry: 3.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 15.64,
    cy: 88.1,
    rx: 10.41,
    ry: 3.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "17.33,35.02 17.33,10.46 46.86,10.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "83.12,35.02 83.12,10.46 53.59,10.46  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.69,74.69l-3.92,0l0,0H8.2v-4.83V50.67c2.53,0,4.57,2.05,4.57,4.58v14.62h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.13,61.8h-5.72v-4.38V39.98c2.3,0,4.15,1.86,4.15,4.16v13.28h4.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 15.64,
    y1: 74.69,
    x2: 15.64,
    y2: 87.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11.93,
    y1: 87.44,
    x2: 19.36,
    y2: 87.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.26,74.69l3.42,0l0,0h4.57v-4.83V50.67c-2.53,0-4.57,2.05-4.57,4.58v14.62h-6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.65,61.33h5.62v-4.38V39.51c-2.3,0-4.15,1.86-4.15,4.16v13.28h-3.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "82.88,75.34 17.12,75.34 29.09,50.91 71.05,50.91  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.33,
    y: 75.34,
    className: "st2",
    width: 5.79,
    height: 17.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 35.27,
    y1: 29.82,
    x2: 35.27,
    y2: 42.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 41.37,
    y1: 26.94,
    x2: 41.37,
    y2: 42.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 47.27,
    y1: 28.17,
    x2: 47.27,
    y2: 42.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 53.19,
    y1: 21.26,
    x2: 53.19,
    y2: 42.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 59.08,
    y1: 22.19,
    x2: 59.08,
    y2: 42.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 65.18,
    y1: 19.3,
    x2: 65.18,
    y2: 42.25
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 84.64,
    cy: 88.1,
    rx: 10.41,
    ry: 3.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 84.64,
    y1: 74.69,
    x2: 84.64,
    y2: 87.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 80.93,
    y1: 87.44,
    x2: 88.36,
    y2: 87.44
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBooking);
export default __webpack_public_path__ + "static/media/Room_Booking.7d6f539a112df3f10dcab2c36b99f8bc.svg";
export { ForwardRef as ReactComponent };